<template>
	<input type="text" class="form-control bg-white" readonly v-model="mydate"/>
</template>
<script>
export default {
    components: {
    },
    props: {
        value: {
            default: ''
        }
    },
    watch: {
        value (value, old) {
        	if (value == '') value =  moment()
            $(this.$el).data('daterangepicker').setStartDate(value)
        	$(this.$el).data('daterangepicker').setEndDate(value)
        },
    },
    mounted () {
    	var self = this;
        $(this.$el).daterangepicker({
        	autoUpdateInput : false,
            singleDatePicker: true,
            showDropdowns: true,
        }).on('apply.daterangepicker', function(ev, picker) {
        	self.mydate = picker.startDate.format('MM/DD/YYYY');
		});
        this.initialize();
    },
    computed: {
    	mydate : {
    		get : function(){
    			return this.value
    		},
    		set : function(value){
    			this.$emit('input', value)
    		}
    	}
    },
    methods : {
        initialize(){
        },
        clear : function(){
        	this.mydate = ''
        }
    }
};
</script>
</script>